import type {ReactAction} from '@netx/core/bootstrap';
import {faEye} from '@fortawesome/pro-solid-svg-icons';
// import {type IAsset} from '@netx/core-asset-next/schema';
import {canViewAssetProjectReview} from '../enablers';
import {AssetProjectReviewActionLabel} from '../locales';
// import {ASSET_PROJECT_EVENT} from './constants';
import {IAssetProjectReview} from '../schema';

export const assetProjectActionViewReviewIcon = faEye;

/**
 * ViewReview asset to project
 * @param params
 * @returns Action
 */
export const assetProjectActionViewReview = (
	review: IAssetProjectReview,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'asset-project-view-review',
	enableTest: () => canViewAssetProjectReview(review),
	cb: () => {},
	icon: assetProjectActionViewReviewIcon,
	get label() {
		return AssetProjectReviewActionLabel.VIEW;
	},
	...params,
});

export default assetProjectActionViewReview;
